<template>

  <div>

     <list-filters
      :trigger-filter.sync="triggerFilter"
      :data-filter.sync="dataFilter"
    />

    <!-- Table Container Card -->
    <!-- <b-card
      no-body
      class="mb-0"
    >

      <div class="m-2">
        <b-row>
          <b-col
            cols="12"
            md="6"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >
            <label>Tampilkan</label>
            <v-select
              v-model="perPage"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="perPageOptions"
              :clearable="false"
              class="per-page-selector d-inline-block mx-50"
            />
            <label>entri</label>
          </b-col>

          <b-col
            cols="12"
            md="6"
          >
            <div class="d-flex align-items-center justify-content-end">
            </div>
          </b-col>
        </b-row>

      </div>

      <b-table
        ref="refUserListTable"
        class="position-relative"
        :items="fetchDatas"
        responsive
        :fields="tableColumns"
        primary-key="id"
        :sort-by.sync="sortBy"
        show-empty
        empty-text="Tidak ada data yang ditemukan"
        :sort-desc.sync="isSortDirDesc"
        style="text-align:center;"
      >

        <template #cell(status)="data">
          <b-media vertical-align="center">
              <b-badge pill :variant="'light-'+data.item.color" >{{ data.item.status }}</b-badge>
          </b-media>
        </template>

        <template #cell(catatan)="data">
          <b-media vertical-align="center">
              <b-badge pill :variant="'light-danger'" >{{ data.item.catatan }}</b-badge>
          </b-media>
        </template>


        <template #cell(actions)="data">
          <div class="d-flex justify-content-center">
          
            <b-button class="mr-1 btn-icon btn btn-relief-primary" variant="primary" :to="{ name: 'pengajuan-sidang-edit', params: { uuid: data.item.uuid } }" title="Ubah Data"
            v-if="data.item.status == 'Draft' && data.item.role == 'mahasiswa' && $can('edit', 'persidangan')"
            >
              <feather-icon icon="EditIcon" />
            </b-button>

            <b-button
              class="btn-icon btn btn-relief-primary"
              variant="outline-danger"
              @click="deleteData(data.item.uuid)"
              v-if="data.item.status == 'Draft' && data.item.role == 'mahasiswa' && $can('delete', 'persidangan')"
            >
              <feather-icon icon="TrashIcon" />
            </b-button>

             <b-button class="mr-1 btn-icon btn btn-relief-primary" variant="primary" :to="{ name: 'pengajuan-sidang-readonly', params: { uuid: data.item.uuid } }" title="Ubah Data"
            v-if="data.item.status == 'Terjadwal' && (data.item.is_pembimbing == false || data.item.is_pembimbing == true)"
            >
              <feather-icon icon="SearchIcon" />
            </b-button>

          
            <b-button class="mr-1 btn-icon btn btn-relief-primary" variant="primary" :to="{ name: 'pengajuan-sidang-readonly', params: { uuid: data.item.uuid } }" title="Ubah Data"
            v-if="data.item.status == 'Menunggu Konfirmasi Pembimbing' && data.item.is_pembimbing == true"
            >
              <feather-icon icon="SearchIcon" />
            </b-button>

            <b-button class="ml-1 mr-1 btn-icon btn btn-relief-primary" variant="primary" :to="{ name: 'pengajuan-sidang-readonly', params: { uuid: data.item.uuid } }" title="Ubah Data"
            v-if="(!data.item.is_pembimbing)"
            >
              <feather-icon icon="SearchIcon" />
            </b-button>

          
          </div>           
        </template>

      </b-table>
      <div class="mx-2 mb-2">
        <b-row>

          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-start"
          >
            <span class="text-muted">Tampilkan {{ dataMeta.from }} hingga {{ dataMeta.to }} dari {{ dataMeta.of }} entri</span>
          </b-col>
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-end"
          >

            <b-pagination
              v-model="currentPage"
              :total-rows="totalUsers"
              :per-page="perPage"
              first-number
              last-number
              class="mb-0 mt-1 mt-sm-0"
              prev-class="prev-item"
              next-class="next-item"
            >
              <template #prev-text>
                <feather-icon
                  icon="ChevronLeftIcon"
                  size="18"
                />
              </template>
              <template #next-text>
                <feather-icon
                  icon="ChevronRightIcon"
                  size="18"
                />
              </template>
            </b-pagination>

          </b-col>

        </b-row>
      </div>
    </b-card> -->
  </div>
</template>

<script>
import {
  BCard, BRow, BCol, BFormInput, BButton, BTable, BMedia, BAvatar, BLink,
  BBadge, BDropdown, BDropdownItem, BPagination,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import store from '@/store'
import { ref, onUnmounted } from '@vue/composition-api'
import {
  deletePengajuanSidang
} from '@/connection-api/master'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { avatarText } from '@core/utils/filter'
import storeModule from '@/connection-api/daftar-sidang/storeModule'
import useList from '@/connection-api/daftar-sidang/list'
import listFilters from './ListFilters.vue'

export default {
  components: {
    listFilters,
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BDropdown,
    BDropdownItem,
    BPagination,
    BBadge,

    vSelect,
  },
  data() {
    return {
      jenisUptOptions: {
        selected: 'id',
        options: [
          { value: null, label: '--Pilih Jenis UPT --' },
        ],
      },
      kanwilOptions: {
        selected: 'id',
        options: [
          { value: null, label: '--Pilih Jenis Kanwil --' },
        ],
      },
      uptOptions: {
        selected: 'id',
        options: [
          { value: null, label: '--Pilih UPT --' },
        ],
      },
      jenisAssetOptions: {
        selected: 'id',
        options: [
          { value: null, label: '--Pilih Jenis Asset --' },
        ],
      },
      statusAssetOptions: {
        selected: 'id',
        options: [
          { value: null, label: '--Pilih Status Asset --' },
        ],
      },
    }
  },
  async mounted() {
  },
  methods: {
    async deleteData(id){
      if (confirm('Anda yakin ingin menghapus data ini?')) {
        const response = await deletePengajuanSidang(id)
        if(response.data.success === true){
          this.$toast({
              component: ToastificationContent,
              position: 'top-right',
              props: {
                title: 'Pengajuan Sidang',
                icon: 'CoffeeIcon',
                variant: 'success',
                text: 'Data berhasil di hapus',
              },
            })
            this.refetchData()
        }else{
          this.$toast({
              component: ToastificationContent,
              position: 'top-right',
              props: {
                title: 'Pengajuan Sidang',
                icon: 'CoffeeIcon',
                variant: 'danger',
                text: 'Data gagal di hapus',
              },
            })
        }
      }
    },
    mappingSelectOption(master, name) {
      if (master.length > 0) {
        master.forEach(element => {
          name.push({
            label: element.nama,
            value: element.id,
          })
        })
      }
    },
  },
  setup() {
    const USER_APP_STORE_MODULE_NAME = 'daftar-sidang'

    if (!store.hasModule(USER_APP_STORE_MODULE_NAME)) store.registerModule(USER_APP_STORE_MODULE_NAME, storeModule)

    onUnmounted(() => {
      if (store.hasModule(USER_APP_STORE_MODULE_NAME)) store.unregisterModule(USER_APP_STORE_MODULE_NAME)
    })

    const isAddNewUserSidebarActive = ref(false)

    const {
      fetchDatas,
      tableColumns,
      perPage,
      currentPage,
      totalUsers,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refUserListTable,
      refetchData,

      resolveUserRoleVariant,
      resolveUserRoleIcon,
      resolveUserStatusVariant,

      triggerFilter,
      dataFilter,
    } = useList()

    return {

      isAddNewUserSidebarActive,

      fetchDatas,
      tableColumns,
      perPage,
      currentPage,
      totalUsers,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refUserListTable,
      refetchData,

      avatarText,

      resolveUserRoleVariant,
      resolveUserRoleIcon,
      resolveUserStatusVariant,

      triggerFilter,
      dataFilter,
    }
  },
}
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
